import React, { forwardRef } from "react";
import { Box } from "@mui/material";
import { ReactComponent as Calender } from "../../assets/images/sidebarCalendar.svg";

interface CustomTextFieldProps {
    setOpen?: (value: React.SetStateAction<boolean>) => void;
    InputProps?: {
        ref?: React.Ref<HTMLDivElement>;
    };
}

const CustomTextField = forwardRef<HTMLDivElement, CustomTextFieldProps>(
    function CustomTextField(props) {
        const { setOpen, InputProps } = props;

        return (
            <Box
                ref={InputProps?.ref}
                onClick={() => setOpen?.((prev: boolean) => !prev)}
                sx={{ display: "flex", cursor: "pointer" }}
            >
                <Calender />
            </Box>
        );
    }
);

export default CustomTextField;